import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import { alpha, useTheme } from '@mui/material/styles';
import { ButtonGroup, Button } from '@mui/material';

import img_01 from '../../data/icons/location.png';


type Props = {}


declare global {
    interface Window {
        kakao: any;
        }
    }

const Location = (props: Props) => {    
    const theme = useTheme();

    // btn group arr datas
    const btnGrpArr: string[] = ['연세 FC 축구 센터', '연세 FC 사무실', '야외구장'];
    const [ btnGrp, setBtnGrp ] = useState<string>('연세 FC 축구 센터');
    
    const handleBtnGrp = (event: any) => {
        switch (event.target.innerText) {
            case "연세 FC 축구 센터":
                setBtnGrp('연세 FC 축구 센터');
                break;
            case "연세 FC 사무실":
                setBtnGrp('연세 FC 사무실');
                break;
            case "야외구장":
                setBtnGrp('야외구장');
                break;
        }
    };

    const mapScript = document.createElement("script");
        mapScript.async = true;
        mapScript.src = `//dapi.kakao.com/v2/maps/sdk.js?appkey=${process.env.REACT_APP_KAKAO_MAP_API_KEY}&autoload=false&libraries=services,clusterer,drawing`;
        document.head.appendChild(mapScript);

    useEffect(() => {
        const onLoadKakaoMap = () => {
                window.kakao.maps.load(() => {

                    const container = document.getElementById("kakaoMap");
                    //지도를 생성할 때 필요한 기본 옵션: 메인 센터에 해당

                    // location별 지도 옵션 set
                    const options_center = {
                        // center: new window.kakao.maps.LatLng(37.360450718724984, 127.32104688524153), //지도의 중심좌표.
                        center: new window.kakao.maps.LatLng(37.36135465668676, 127.31662298751434),
                        level: 2,  //지도의 레벨(확대, 축소 정도)
                    };
                    
                    const options_office = {
                        center: new window.kakao.maps.LatLng(37.359071568094855, 127.31959900229299),
                        level: 2,  //지도의 레벨(확대, 축소 정도)
                    };
                    
                    const options_dom = {
                        center: new window.kakao.maps.LatLng(37.36053933310957, 127.32076506385351),
                        level: 2,  //지도의 레벨(확대, 축소 정도)
                    };

                    // locations lat&lng
                    const latLng_center = new window.kakao.maps.LatLng(37.36135465668676, 127.31662298751434);
                    const latLng_office = new window.kakao.maps.LatLng(37.359071568094855, 127.31959900229299);
                    const latLng_dom = new window.kakao.maps.LatLng(37.36053933310957, 127.32076506385351);

                    // 컴포넌트에 맵 표시, 마커찍기, 상세정보 overlay를 지정해 줄 함수
                    const setLocationData = (options: object, latLng: any, content: any ) => {
                        const map = new window.kakao.maps.Map(container, options);
                        const markerPosition_center = latLng;
                        const marker = new window.kakao.maps.Marker({
                                map: map,
                                position: markerPosition_center,
                            });
                            marker.setMap(map);
                        const overlay = new window.kakao.maps.CustomOverlay({
                                content: content,
                                map: map,
                                    position: marker.getPosition()       
                            });
                            window.kakao.maps.event.addListener(marker, 'click', () => {
                                overlay.setMap(map);
                            });
                            // 드래그 줌 기능 설정
                            map.setDraggable(false);    
                            map.setZoomable(false);
                    };

                    // 지도의 중심을 결과값으로 받은 위치로 이동
                    if (btnGrp === '연세 FC 축구 센터') {
                        setLocationData(options_center, latLng_center, content_center);
                    } else if (btnGrp === '연세 FC 사무실') {
                        setLocationData(options_office, latLng_office, content_office);
                    } else if (btnGrp === '야외구장') {
                        setLocationData(options_dom, latLng_dom, content_dom);
                    };

                });
            };
            mapScript.addEventListener("load", onLoadKakaoMap);
        return () => mapScript.removeEventListener("load", onLoadKakaoMap);
    }, [btnGrp]);


    // 커스텀 오버레이에 표시할 컨텐츠 
    const content_center = '<div class="wrap">' + 
        '    <div class="info">' + 
        '        <div class="title">' + 
        '            연세 FC 축구 센터' + 
        '            <div class="close" title="닫기"></div>' + 
        '        </div>' + 
        '        <div class="body">' + 
        '            <div class="img">' +
        '                <img src="https://search.pstatic.net/common/?autoRotate=true&quality=100&type=f640_380&src=https%3A%2F%2Fldb-phinf.pstatic.net%2F20201001_192%2F1601515969879XakzD_JPEG%2F4I8HbXx8TFVqndZQdk2i3Jcp.jpg" width="73" height="70">' +
        '           </div>' + 
        '            <div class="desc">' + 
        '                <div class="ellipsis">경기 광주시 초월읍 경충대로 860</div>' + 
        '                <div class="jibun ellipsis">(우) 464962 (지번) 산이리 3-18</div>' + 
        '                <div>031-764-2579</div>' + 
        '            </div>' + 
        '        </div>' + 
        '    </div>' +    
        '</div>';

    const content_office = '<div class="wrap">' + 
        '    <div class="info">' + 
        '        <div class="title">' + 
        '            연세 FC 사무실' + 
        '            <div class="close" title="닫기"></div>' + 
        '        </div>' + 
        '        <div class="body">' + 
        '            <div class="img">' +
        '                <img src="https://search.pstatic.net/common/?autoRotate=true&quality=100&type=f640_380&src=https%3A%2F%2Fldb-phinf.pstatic.net%2F20201001_192%2F1601515969879XakzD_JPEG%2F4I8HbXx8TFVqndZQdk2i3Jcp.jpg" width="73" height="70">' +
        '           </div>' + 
        '            <div class="desc">' + 
        '                <div class="ellipsis">경기 광주시 초월읍 경충대로 830</div>' + 
        '                <div class="jibun ellipsis">(우) 12800 (지번) 삼리 173-7 </div>' + 
        '                <div>031-764-2579</div>' + 
        '            </div>' + 
        '        </div>' + 
        '    </div>' +    
        '</div>';

    const content_dom = '<div class="wrap">' + 
        '    <div class="info">' + 
        '        <div class="title">' + 
        '            야외구장' + 
        '            <div class="close" title="닫기"></div>' + 
        '        </div>' + 
        '        <div class="body">' + 
        '            <div class="img">' +
        '                <img src="https://search.pstatic.net/common/?autoRotate=true&quality=100&type=f640_380&src=https%3A%2F%2Fldb-phinf.pstatic.net%2F20201001_192%2F1601515969879XakzD_JPEG%2F4I8HbXx8TFVqndZQdk2i3Jcp.jpg" width="73" height="70">' +
        '           </div>' + 
        '            <div class="desc">' + 
        '                <div class="ellipsis">경기 광주시 곤지암읍 평촌길 12-137</div>' + 
        '                <div class="jibun ellipsis">(우) 12800 (지번) 삼리 612-14 </div>' + 
        '                <div>031-764-2579</div>' + 
        '            </div>' + 
        '        </div>' + 
        '    </div>' +    
        '</div>';

    return (
        <>
            <Box sx={{ width: '100%', padding: '0em', mb: 15 }}>
                <Box 
                    position={'relative'}
                    zIndex={2} 
                    sx={{ 
                        // border: '1px solid #dedede', 
                        borderRadius: '15px', 
                        padding: '0em' ,
                        }}>
                    <Box>
                    <Box marginBottom={1}>
                    <Typography sx={{ textAlign: 'center' }}>
                        <img src={img_01} width={100} />
                    </Typography>
                        <Typography
                            sx={{
                            textTransform: 'uppercase',
                            fontWeight: '600',
                            }}
                            gutterBottom
                            color={'primary.main'}
                            align={'center'}
                        >
                            Location
                        </Typography>
                        <Typography
                        variant="h4"
                        sx={{
                            fontWeight: 700,
                            textAlign: 'center',
                            '@media (max-width: 1300px)': {
                                fontSize: '1.5em',
                            }
                        }}
                        >
                        연세 FC 위치
                        </Typography>
                    </Box>
                    <Box>
                        <ButtonGroup 
                            size="medium" 
                            aria-label="large button group" 
                            sx={{ 
                                mt: 1, 
                                mb: 1,
                                // justifyContent: 'center',
                                // boxShadow: 2,
                                '@media (max-width: 600px)': {
                                    display: 'flex',
                                    justifyContent: 'center'
                                }
                                }}
                            >
                                {btnGrpArr.map((item) => (
                                    <>
                                        <Button 
                                            key={item} 
                                            onClick={handleBtnGrp}
                                            sx={{
                                                backgroundColor: btnGrp === item ? '#308cff': '#ffffff',
                                                color: btnGrp === item ? '#ffffff': 'primary',
                                                '&:hover': {
                                                    backgroundColor: btnGrp === item ? '#439dff': '#fafafa'
                                                },
                                                '@media (max-width: 600px)': {
                                                    fontSize: '0.8em',
                                                    mt: 1,
                                                }
                                            }}
                                            >{item}</Button>
                                    </>
                                ))}
                        </ButtonGroup>
                    </Box>
                    </Box>
                    <Box 
                        id="kakaoMap"
                        // marginY={3} 
                        sx={{ 
                            width: '100%',
                            height: 'auto',
                            boxShadow: 'rgba(0, 0, 0, 0.1) 1px 10px 20px',
                            minHeight: 600,
                            borderRadius: '15px',
                            filter:
                                theme.palette.mode === 'dark'
                                ? 'grayscale(0.5) opacity(0.7)'
                                : 'none',
                            '@media (max-width: 1300px)': {
                                padding: 3
                            }
                        }}>
                        {/* <div id="kakaoMap" style={{ width: '100%', height: '500px', borderRadius: '15px' }} /> */}
                    </Box>
                    <Grid container spacing={2} p={2}>
                    {/* <Grid item xs={12} sm={6}>
                        <Typography
                        variant={'body1'}
                        gutterBottom
                        sx={{ fontWeight: '600' }}
                        >
                            📞 Call us
                        </Typography>
                        <Typography variant={'subtitle1'}>031-764-2579</Typography>
                    </Grid> */}
                    {/* <Grid item xs={12} sm={6}>
                        <Typography
                        variant={'body1'}
                        gutterBottom
                        sx={{ fontWeight: '600' }}
                        >
                            📭 Email us
                        </Typography>
                        <Typography variant={'subtitle1'}>
                            gyun3737@naver.com
                        </Typography>
                    </Grid> */}
                    {/* <Grid item xs={6}>
                        <Typography
                        variant={'body1'}
                        gutterBottom
                        sx={{ fontWeight: '600' }}
                        >
                            ⚽ Address
                        </Typography>
                        <Typography variant={'subtitle1'}>
                            {
                                btnGrp === "연세 FC 축구 센터" && (<>경기 광주시 초월읍 경충대로 860<br />(지번) 산이리 3-18</>) ||
                                btnGrp === "연세 FC 사무실" && (<>경기 광주시 초월읍 경충대로 830<br />(지번) 산이리 173-7</>) ||
                                btnGrp === "야외구장" && (<>경기 광주시 곤지암읍 평촌길 12-137<br />(지번) 산이리 612-14</>)
                            }
                        </Typography>
                    </Grid> */}
                    </Grid>
                </Box>
            </Box>
        </>
    )
}

export default Location